import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import {ReactNode, useCallback, useMemo, useState} from "react";
import {AppFwError, handleError} from "../../api-client/AppFwApiClient.ts";

interface DialogAction {
    label: string;
    action?: () => Promise<void>;
}

interface DialogActionButtonProps {
    outlet: ReactNode;
    dialogTitle?: string;
    dialogContent?: string;
    disabled?: boolean;
    dialogActions: DialogAction[];
}

export default function DialogActionButton(props: DialogActionButtonProps) {

    const [open, setOpen] = useState(false)
    const [error, setError] = useState<null | AppFwError>()

    const handleClick = useCallback(
        () => {
            setOpen(true)
        },
        [setOpen],
    )

    const dialogActions = useMemo(() => {
        return props.dialogActions.map((action, index) =>
            <Button
                autoFocus={index === props.dialogActions.length - 1} // TODO?
                key={index}
                onClick={async () => {
                    let r: null | Promise<void> = null
                    setError(null)
                    try {
                        if (action.action) {
                            r = action.action()
                        }
                        if (r) {
                            r.then(() => {
                                setOpen(false)
                            })
                            .catch(async (e) => {
                                return setError(await handleError(e));
                            })
                        } else {
                            setOpen(false)
                        }
                    } catch (e) {
                        setError(await handleError(e))
                    }
                }}
            >
                {action.label}
            </Button>
        )
    }, [props.dialogActions, setError])

    return (
        <>
            <Button component="span" disabled={props.disabled == true} onClick={handleClick}>
                {props.outlet}
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle id="alert-dialog-title">
                    {props.dialogTitle}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.dialogContent}
                    </DialogContentText>

                    {error && (<Alert sx={{ marginTop: 2 }} severity="error">{error.message}</Alert>)}

                </DialogContent>
                <DialogActions>{dialogActions}</DialogActions>
            </Dialog>
        </>
    )
}